// prettier-ignore
// main.js используется для создания и монтирования приложения Vue.
// Он импортирует функцию createApp из библиотеки Vue и компонент App.vue, который является корневым
// компонентом приложения. Затем он создает экземпляр приложения с помощью createApp(App) и монтирует
// его на элемент с id "app" в HTML-документе.
import { createApp } from "vue";
import App from "./App.vue";
import AOS from "aos";
import "./assets/main.css";
import "aos/dist/aos.css";
import router from "./router";
// Импортируем все компоненты связанные с сайтом
const app = createApp(App);

// Подключаем роутеры
app.use(router);
// Инициализация библиотеки AOS для плавного появления текста при прокрутке.
AOS.init();
// Кастомная директива для наблюдения за скроллом
app.directive("scroll-animation", {
  mounted(el) {
    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          el.classList.add("opacity-100"); // Добавляем класс видимости
        } else {
          el.classList.remove("opacity-100"); // Удаляем класс видимости
        }
      });
    };

    const observer = new IntersectionObserver(callback, {
      threshold: 0.1, // Пороговое значение видимости (от 0 до 1)
    });
    observer.observe(el);
    el._observer = observer; // Сохраняем observer в DOM-элементе для доступа к нему при удалении
  },
  unmounted(el) {
    // Отключаем наблюдение, когда элемент удаляется из DOM, чтобы избежать утечек памяти
    if (el._observer) el._observer.disconnect();
  },
});

app.mount("#app");
